export default class Loader {
	public static async get(url: string) {
		return await this.request('GET', url);
	}

	public static async post(url: string, body: string) {
		return await this.request('POST', url, body);
	}

	private static async request(method: 'POST' | 'GET', url: string, body?: string) {
		return new Promise<string>(async (resolve, reject) => {
			const xhr = new XMLHttpRequest();
			xhr.onreadystatechange = () => {
				if (xhr.readyState == 4) {
					if (xhr.status === 200) {
						resolve(xhr.responseText);
					} else {
						reject(xhr.responseText);
					}
				}
			};
			xhr.open(method, url, true);
			xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
			xhr.onerror = e => {
				reject(e);
			};
			if (body) {
				xhr.send(body);
			} else {
				xhr.send();
			}
			// xhr.send(body ? body : '');
		});
	}
}
